export default {
  'stories:swipe-up': 'Swipe up',
};
